import { IconSize, IconWrapper, Loader, LoaderSize, PrintIcon, Tooltip } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';
import { usePrint } from '../../print/PrintFrame.hooks';

import { StyledLoader } from './PrintIconAction.styled';

type PrintIconActionProps = {
   readonly statisticsId: number;
};

export const PrintIconAction = (props: PrintIconActionProps): JSX.Element => {
   const { isLoading, onPrint } = usePrint(props.statisticsId);

   if (isLoading) {
      return (
         <StyledLoader>
            <Loader testId={'loader'} size={LoaderSize.MEDIUM} />
         </StyledLoader>
      );
   }

   return (
      <Tooltip content={statisticsTranslationKeys.orderTable.actions.print} testId={'printStatistics'}>
         <IconWrapper onClick={onPrint} testId={'printIcon'} size={IconSize.NORMAL}>
            <PrintIcon />
         </IconWrapper>
      </Tooltip>
   );
};
